var map = {
	"./de/returnBtn.png": "1h6a",
	"./en/returnBtn.png": "Egtw",
	"./es/returnBtn.png": "uHWt",
	"./fr/returnBtn.png": "c+O0",
	"./ja/returnBtn.png": "223w",
	"./ko/returnBtn.png": "39W/",
	"./pt/returnBtn.png": "7a3O",
	"./ru/returnBtn.png": "VHHa",
	"./tc/returnBtn.png": "QtRZ",
	"./th/returnBtn.png": "m4Ou"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Wp02";